<div class="search-box" [formGroup]="form">
  <input type="text" formControlName="query">
</div>
<div *ngIf="fetchFailed" class="search-failed">
  Iskanje spodletelo. <span (click)="triggerFetch.next()">Poizkusite znova</span>
</div>
<app-food-list (clicked)="onClick($event)" [foods]="results" [selected]="current"></app-food-list>
